import React from 'react'
import './TodoHeader.css'
function TodoHeader() {
    return (
        <div className="TodoHeader">
            <h2>TODO App</h2>
            <p>By <a href="https://www.linkedin.com/in/gunnala-pranav-reddy-7a230b1b0/">Pranav Reddy Gunnala</a></p>
        </div>
    );
}

export default TodoHeader;